import { useCallback } from 'react'

import { type BreadcrumbItem, useBreadcrumbContext } from '@/contexts/BreadcrumbContext'

export const useBreadcrumbs = () => {
  const { breadcrumbs, setBreadcrumbs, pageTitle, setPageTitle } = useBreadcrumbContext()

  const updateBreadcrumbs = useCallback(
    (newBreadcrumbs: BreadcrumbItem[]) => {
      setBreadcrumbs(newBreadcrumbs)
    },
    [setBreadcrumbs]
  )

  const updatePageTitle = useCallback(
    (title: string | null) => {
      setPageTitle(title)
    },
    [setPageTitle]
  )

  return {
    breadcrumbs,
    setBreadcrumbs: updateBreadcrumbs,
    pageTitle,
    setPageTitle: updatePageTitle
  }
}
